import { faTrash } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButton } from '@mui/material';
import SimpleTooltip from '../../../../../../../../components/SimpleTooltip';

type RemoveLargestJobProps = {
  removeJob: () => void;
};

export function RemoveLargestJob({ removeJob }: RemoveLargestJobProps) {
  return (
    <SimpleTooltip
      title="Remove job"
      enterDelay={500}
      enterNextDelay={500}
      style={{
        marginLeft: 0,
        top: '50%',
        position: 'absolute',
      }}
      placement="top"
    >
      <IconButton
        className="contrast-text"
        style={{
          top: '50%',
          right: -7,
          position: 'absolute',
        }}
        onClick={removeJob}
      >
        <FontAwesomeIcon style={{ fontSize: '1.25rem' }} icon={faTrash} />
      </IconButton>
    </SimpleTooltip>
  );
}
